var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('products-wizard-provider',{staticClass:"g-h-full",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var products = ref.products;
var isLoading = ref.isLoading;
var productsPage = ref.productsPage;
var productsPerPage = ref.productsPerPage;
var getNextProductsPage = ref.getNextProductsPage;
var getPreviousProductsPage = ref.getPreviousProductsPage;
var campaign = ref.campaign;
return [_c('products-list-view',{attrs:{"products":products,"campaign":campaign,"is-loading":isLoading,"current-page":productsPage,"per-page":productsPerPage},on:{"next-page":getNextProductsPage,"prev-page":getPreviousProductsPage}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }